/**
 * Isomorphic version of window.requestIdleCallback
 * Useful for scheduling tasks off the current event loop to avoid interrupting things like animations
 * Fallback to setTimeout(callback, 0) when not available.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback
 */
export default function requestIdleCallback(callback, options) {
    if (typeof globalThis.requestIdleCallback !== 'undefined') {
        return globalThis.requestIdleCallback(callback, options);
    }
    // requestIdleCallback is not supported in this environment
    return setTimeout(callback, 0);
}
//# sourceMappingURL=requestIdleCallback.js.map